import '@patternfly/react-core/dist/styles/base.css'; // This import needs to be first
import '@casa/kaoto-extension/register';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { ColorScheme } from './models';
import { router } from './router';
import { setColorScheme } from './utils/color-scheme';

/*
 * The theme, before anything renders.
 *
 * `App` applies the saved preference, but the sign-in screen is above `App` and would otherwise
 * paint with no theme class at all — which on a dark desktop gives dark text tokens on a light
 * card, i.e. a form you cannot read. Auto is the right first guess; `App` corrects it to whatever
 * was actually chosen as soon as it mounts.
 */
setColorScheme(ColorScheme.Auto);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  /*
   * <React.StrictMode>
   * </React.StrictMode>,
   */

  <RouterProvider router={router} />,
);
